export type CheckAtLevel = 'LineItem' | 'Request';
export type FieldCategory = 'standard' | 'checkpoint' | 'static';

export const DrlsApiOperation = {
  CRD: [
    'appointment-book',
    'order-sign',
    'order-dispatch',
    'order-select',
    'encounter-start',
    'encounter-discharge'
  ],
  DTR: [
    '$questionnaire-package',
    '$next-question',
    '$expand',
    '$log-questionnaire-errors'
  ],
  PAS: [
    '$submit',
    '$inquire',
    '$submit-attachment'
  ],
} as const;

export type DrlsApi = keyof typeof DrlsApiOperation;

type FhirPath = {
  path: string;
  drls_apis: {
    [K in DrlsApi]: {
      type: '';
      sub_type: string[];
    };
  }[DrlsApi][]
};

export interface PACustomFieldOption {
  PK: string;
  SK: string;
  field_key: string;
  fhir_path: FhirPath[];
  field_label: string;
  field_category: FieldCategory[];
  check_at_level: CheckAtLevel[]
  orgs_id: string;
  entity_type: string;
  create_date: string;
  modify_date: string;
  created_by: string;
  modified_by: string;
}